<template>
    <div class="sma">
        <div class="sma-main">
            <nav class="sma-crumb">
                <button type="button" class="sma-crumb-link" @click="goBack">研修空间</button>
                <span class="sma-crumb-sep">/</span>
                <span class="sma-crumb-current">成员活跃度统计</span>
            </nav>
            <div class="sma-panel">
                <div class="sma-toolbar">
                    <el-form :inline="true" class="sma-filter-bar" @submit.native.prevent>
                        <el-form-item label="校级空间">
                            <el-select v-model="filterSchool" size="small" clearable filterable
                                placeholder="全部校级空间" style="width: 280px" @change="onFilterChange">
                                <el-option label="全部校级空间" value="" />
                                <el-option v-for="item in schoolOptions" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="角色">
                            <el-select v-model="filterRole" size="small" clearable placeholder="全部角色"
                                style="width: 120px" @change="onFilterChange">
                                <el-option label="全部角色" value="" />
                                <el-option label="徒弟" :value="3" />
                                <el-option label="师傅" :value="2" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model.trim="filterSearch" size="small" clearable
                                placeholder="搜索子空间、姓名…" suffix-icon="el-icon-search"
                                style="width: 240px" @input="onSearchInput" @clear="onFilterChange" />
                        </el-form-item>
                    </el-form>
                    <div class="sma-toolbar-actions">
                        <el-button type="primary" size="small" icon="el-icon-download" :loading="exporting"
                            @click="exportList">导出</el-button>
                    </div>
                </div>

                <div class="sma-panel-body" v-loading="listLoading">
                    <el-table :data="list" stripe style="width: 100%">
                        <el-table-column label="成员" min-width="140" align="center" fixed>
                            <template slot-scope="{ row }">
                                <div class="sma-user-cell">
                                    <span class="sma-avatar" :class="avatarClass(row.role)">{{ nameInitial(row) }}</span>
                                    <div class="sma-user-name-wrap">
                                        <div class="sma-user-name" :title="row.userName || ''">{{ row.userName || '—' }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="角色" width="80" align="center">
                            <template slot-scope="{ row }">
                                <el-tag size="mini" :type="Number(row.role) === 2 ? 'warning' : ''">
                                    {{ roleText(row) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="手机号" width="120" show-overflow-tooltip>
                            <template slot-scope="{ row }">{{ row.phone || '—' }}</template>
                        </el-table-column>
                        <el-table-column label="校级空间" min-width="160" align="center">
                            <template slot-scope="{ row }">
                                <div class="sma-clamp" :title="row.parentSpxName || ''">{{ row.parentSpxName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="子空间" min-width="140" align="center">
                            <template slot-scope="{ row }">
                                <div class="sma-subspace">
                                    <div class="sma-subspace-inner">
                                        <div class="sma-clamp" :title="row.spxName || ''">{{ row.spxName }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="登录次数" width="90" align="center">
                            <template slot-scope="{ row }">{{ row.loginCount || 0 }}次</template>
                        </el-table-column>
                        <el-table-column min-width="170" align="center">
                            <template slot="header">
                                <el-tooltip content="在线时长 = 直播课学习时长 + 看回放时长 + 个人日志录屏时长" placement="top">
                                    <span>在线时长</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="{ row }">
                                <div class="sma-duration">
                                    <div class="sma-duration-total">{{ formatDuration(row.onlineSeconds) }}</div>
                                    <el-tooltip placement="top">
                                        <div slot="content">直播课学习<br>看回放<br>日志录屏</div>
                                        <div class="sma-duration-sources">
                                            <span class="sma-duration-item">
                                                <i class="sma-duration-dot live"></i>直播 {{ formatDuration(row.liveSeconds) }}
                                            </span>
                                            <span class="sma-duration-item">
                                                <i class="sma-duration-dot replay"></i>回放 {{ formatDuration(row.replaySeconds) }}
                                            </span>
                                            <span class="sma-duration-item">
                                                <i class="sma-duration-dot record"></i>录屏 {{ formatDuration(row.recordSeconds) }}
                                            </span>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="组卷次数" width="90" align="center">
                            <template slot-scope="{ row }">{{ displayCompose(row) }}</template>
                        </el-table-column>
                        <el-table-column label="批注次数" width="90" align="center">
                            <template slot-scope="{ row }">{{ displayNote(row) }}</template>
                        </el-table-column>
                        <el-table-column label="建课次数" width="90" align="center">
                            <template slot-scope="{ row }">{{ row.courseCount || 0 }}次</template>
                        </el-table-column>
                        <el-table-column label="提交作业数量" width="110" align="center">
                            <template slot-scope="{ row }">{{ row.homeworkCount || 0 }}份</template>
                        </el-table-column>
                        <el-table-column label="上传资源数量" width="110" align="center">
                            <template slot-scope="{ row }">{{ row.resourceCount || 0 }}个</template>
                        </el-table-column>
                        <template slot="empty">
                            <el-empty description="没有匹配的成员" />
                        </template>
                    </el-table>
                </div>

                <div v-show="total" class="sma-pagination">
                    <pagination :total="total" :page.sync="page" :limit.sync="pageSize" :pageSizes="[10, 20, 30]"
                        @pagination="onPageChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { saveAs } from 'file-saver';
    import pagination from '@/common/community/pagination.vue';

    const EXPORT_LIMIT = 100;

    export default {
        name: 'SpaceMemberActivity',
        components: { pagination },
        data() {
            return {
                list: [],
                total: 0,
                listLoading: false,
                exporting: false,
                schoolOptions: [],
                filterSchool: '',
                filterRole: '',
                filterSearch: '',
                page: 1,
                pageSize: 10,
                searchTimer: null,
            };
        },
        computed: {
            ...mapState({
                currentProject: (state) => state.user.currentProject,
            }),
            projectId() {
                return this.currentProject && this.currentProject.id;
            },
        },
        watch: {
            projectId: {
                immediate: true,
                handler() {
                    this.page = 1;
                    this.fetchSchoolOptions();
                    this.fetchList();
                },
            },
        },
        beforeDestroy() {
            clearTimeout(this.searchTimer);
        },
        methods: {
            isApiOk(res) {
                return res && (res.code === 200 || res.code === '200');
            },
            goBack() {
                this.$router.push('/home/subspaceManage');
            },
            buildQuery(page, limit) {
                const query = {
                    page,
                    limit,
                };
                if (this.filterSchool) query.parentSpxId = this.filterSchool;
                if (this.filterRole !== '' && this.filterRole != null) query.role = this.filterRole;
                if (this.filterSearch) query.keyword = this.filterSearch;
                return query;
            },
            async fetchSchoolOptions() {
                if (!this.projectId) {
                    this.schoolOptions = [];
                    return;
                }
                try {
                    const res = await this.$Api.Paired.getListByProject({
                        page: 1,
                        limit: 999,
                        projectId: this.projectId,
                        createType: 1,
                    });
                    if (!this.isApiOk(res)) {
                        this.schoolOptions = [];
                        return;
                    }
                    const records = (res.data && res.data.records) || [];
                    this.schoolOptions = records.map((item) => ({
                        value: item.id,
                        label: item.spxName || '',
                    }));
                } catch (e) {
                    this.schoolOptions = [];
                }
            },
            async fetchList() {
                this.listLoading = true;
                try {
                    const res = await this.$Api.Paired.getPartnerActivity(this.buildQuery(this.page, this.pageSize));
                    if (!this.isApiOk(res)) {
                        this.list = [];
                        this.total = 0;
                        this.$message.error((res && res.msg) || '获取成员活跃度失败');
                        return;
                    }
                    const pageData = res.data || {};
                    this.list = pageData.records || [];
                    this.total = Number(pageData.total) || 0;
                } catch (e) {
                    this.list = [];
                    this.total = 0;
                    this.$message.error('获取成员活跃度失败');
                } finally {
                    this.listLoading = false;
                }
            },
            onFilterChange() {
                this.page = 1;
                this.fetchList();
            },
            onSearchInput() {
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.onFilterChange();
                }, 300);
            },
            onPageChange() {
                this.fetchList();
            },
            nameInitial(row) {
                const name = row && row.userName ? String(row.userName) : '';
                return name.slice(0, 1) || '—';
            },
            avatarClass(role) {
                return Number(role) === 2 ? 'master' : 'apprentice';
            },
            roleText(row) {
                if (row && row.roleName) return row.roleName;
                if (Number(row && row.role) === 2) return '师傅';
                if (Number(row && row.role) === 3) return '徒弟';
                return '—';
            },
            formatDuration(seconds) {
                const n = Number(seconds) || 0;
                if (n <= 0) return '0min';
                const h = Math.floor(n / 3600);
                const m = Math.floor((n % 3600) / 60);
                if (h && m) return h + 'h ' + m + 'min';
                if (h) return h + 'h';
                if (m) return m + 'min';
                return n + 's';
            },
            displayCompose(row) {
                if (Number(row.role) === 2) return '—';
                return (row.composeCount || 0) + '次';
            },
            displayNote(row) {
                if (Number(row.role) === 3) return '—';
                return (row.noteCount || 0) + '次';
            },
            csvCell(value) {
                const text = value == null ? '' : String(value);
                if (/[",\n]/.test(text)) return '"' + text.replace(/"/g, '""') + '"';
                return text;
            },
            async fetchAllRecords() {
                const first = await this.$Api.Paired.getPartnerActivity(this.buildQuery(1, EXPORT_LIMIT));
                if (!this.isApiOk(first)) {
                    throw new Error((first && first.msg) || '获取成员活跃度失败');
                }
                const pageData = first.data || {};
                const total = Number(pageData.total) || 0;
                const records = (pageData.records || []).slice();
                const pages = Math.ceil(total / EXPORT_LIMIT);
                for (let page = 2; page <= pages; page += 1) {
                    const res = await this.$Api.Paired.getPartnerActivity(this.buildQuery(page, EXPORT_LIMIT));
                    if (!this.isApiOk(res)) {
                        throw new Error((res && res.msg) || '获取成员活跃度失败');
                    }
                    const more = (res.data && res.data.records) || [];
                    records.push.apply(records, more);
                }
                return records;
            },
            async exportList() {
                if (this.exporting) return;
                this.exporting = true;
                try {
                    const rows = await this.fetchAllRecords();
                    if (!rows.length) {
                        this.$message.warning('当前没有可导出的成员数据');
                        return;
                    }
                    const headers = [
                        '成员', '角色', '手机号', '校级空间', '子空间', '登录次数',
                        '在线总时长', '直播课学习时长', '看回放时长', '个人日志录屏时长',
                        '组卷次数', '批注次数', '建课次数', '提交作业数量', '上传资源数量',
                    ];
                    const lines = [headers.join(',')];
                    rows.forEach((row) => {
                        lines.push([
                            this.csvCell(row.userName),
                            this.csvCell(this.roleText(row)),
                            this.csvCell(row.phone),
                            this.csvCell(row.parentSpxName),
                            this.csvCell(row.spxName),
                            this.csvCell((row.loginCount || 0) + '次'),
                            this.csvCell(this.formatDuration(row.onlineSeconds)),
                            this.csvCell(this.formatDuration(row.liveSeconds)),
                            this.csvCell(this.formatDuration(row.replaySeconds)),
                            this.csvCell(this.formatDuration(row.recordSeconds)),
                            this.csvCell(this.displayCompose(row)),
                            this.csvCell(this.displayNote(row)),
                            this.csvCell((row.courseCount || 0) + '次'),
                            this.csvCell((row.homeworkCount || 0) + '份'),
                            this.csvCell((row.resourceCount || 0) + '个'),
                        ].join(','));
                    });
                    const stamp = new Date();
                    const pad = (n) => (n < 10 ? '0' + n : '' + n);
                    const filename = '成员活跃度统计_'
                        + stamp.getFullYear() + pad(stamp.getMonth() + 1) + pad(stamp.getDate()) + '_'
                        + pad(stamp.getHours()) + pad(stamp.getMinutes()) + pad(stamp.getSeconds()) + '.csv';
                    const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
                    saveAs(blob, filename);
                } catch (e) {
                    this.$message.error((e && e.message) || '导出失败');
                } finally {
                    this.exporting = false;
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    @primary: #409EFF;
    @text-primary: #303133;
    @text-regular: #606266;
    @text-secondary: #909399;
    @border-light: #EBEEF5;
    @shadow-light: 0 2px 12px rgba(0, 0, 0, 0.08);
    @radius: 8px;

    .sma {
        min-height: 100%;
    }

    .sma-main {
        max-width: 1400px;
        margin: 0 auto;
        padding: 16px 20px 40px;
    }

    .sma-crumb {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;
        font-size: 13px;
        color: #999;
    }

    .sma-crumb-link {
        padding: 0;
        border: none;
        background: none;
        font: inherit;
        color: inherit;
        cursor: pointer;

        &:hover {
            color: @primary;
        }
    }

    .sma-crumb-sep {
        color: #ccc;
    }

    .sma-crumb-current {
        color: @text-regular;
    }

    .sma-panel {
        background: #fff;
        border-radius: @radius;
        box-shadow: @shadow-light;
        overflow: hidden;
    }

    .sma-toolbar {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 16px;
        border-bottom: 1px solid @border-light;
        flex-wrap: wrap;
    }

    .sma-filter-bar {
        margin-bottom: 0;

        /deep/ .el-form-item {
            margin-bottom: 0;
            margin-right: 12px;
        }

        /deep/ .el-form-item__label {
            color: @text-regular;
            padding-right: 8px;
        }
    }

    .sma-toolbar-actions {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    .sma-panel-body {
        padding: 0;
    }

    .sma-user-cell {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        width: 100%;
        text-align: left;
    }

    .sma-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        flex-shrink: 0;

        &.master {
            background: linear-gradient(135deg, #f59e0b, #d97706);
        }

        &.apprentice {
            background: linear-gradient(135deg, #3b82f6, #2563eb);
        }
    }

    .sma-user-name-wrap {
        flex: 1;
        min-width: 0;
        text-align: left;
    }

    .sma-user-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-weight: 600;
        font-size: 13px;
        color: @text-primary;
        line-height: 1.3;
        text-align: left;
        word-break: break-all;
    }

    .sma-clamp {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
    }

    .sma-subspace {
        display: flex;
        justify-content: center;
    }

    .sma-subspace-inner {
        max-width: 100%;
        min-width: 0;
        text-align: left;
    }

    .sma-duration {
        line-height: 1.4;
    }

    .sma-duration-total {
        font-size: 13px;
        font-weight: 600;
        color: @text-primary;
        font-variant-numeric: tabular-nums;
    }

    .sma-duration-sources {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px 10px;
        margin-top: 4px;
    }

    .sma-duration-item {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
        font-size: 11px;
        color: @text-secondary;
        font-variant-numeric: tabular-nums;
    }

    .sma-duration-dot {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        flex-shrink: 0;

        &.live {
            background: #409EFF;
        }

        &.replay {
            background: #67C23A;
        }

        &.record {
            background: #E6A23C;
        }
    }

    .sma-pagination {
        padding: 4px 16px 0;
    }

    /deep/ .el-table {
        border: none;

        &::before {
            display: none;
        }
    }

    /deep/ .el-table__header thead th {
        color: #000;
        font-weight: 600;
        text-align: center;
        background-color: RGBA(250, 251, 255, 1);
    }

    /deep/ .el-table__header thead th .cell {
        text-align: center;
    }

    /deep/ .el-table__empty-block {
        min-height: 200px;
    }
</style>
